import { Flex, Text, Title } from '@collable/ui'

interface VideoDetailHeaderProps {
  isEdit?: boolean
}

const VideoDetailHeader = ({ isEdit = false }: VideoDetailHeaderProps) => {
  return (
    <Flex direction="column" gap={2}>
      <Title size="subTitle1" fontWeight="bold" as="h2">
        {isEdit ? '광고 정보를 수정하세요' : '광고 정보 등록'}
      </Title>
      {!isEdit && (
        <Text size="body2" color="labelAssistive">
          진행했던 영상에 대한 광고 정보를 입력해 주세요
        </Text>
      )}
    </Flex>
  )
}

export default VideoDetailHeader
